<template>
  <div>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               ref="crud"
               v-model="form"
               :page.sync="page"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="refreshChange"
               @on-load="onLoad">
      <template slot="menuLeft">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-circle-plus"
                   v-if="permission.flow_model_create"
                   plain
                   @click="handleCreate">创 建
        </el-button>
        <el-button type="danger"
                   size="small"
                   icon="el-icon-delete"
                   v-if="permission.flow_model_delete"
                   plain
                   @click="handleDelete">删 除
        </el-button>
      </template>
      <template slot-scope="scope"
                slot="menu">
        <el-button type="text"
                   size="small"
                   icon="el-icon-setting"
                   v-if="permission.flow_model_update"
                   @click.stop="handleUpdate(scope.row,scope.index)">配置
        </el-button>
        <el-button type="text"
                   size="small"
                   icon="el-icon-upload2"
                   v-if="permission.flow_model_deploy"
                   @click.stop="handleDeploy(scope.row,scope.index)">部署
        </el-button>
        <el-button type="text"
                   size="small"
                   icon="el-icon-delete"
                   v-if="permission.flow_model_delete"
                   @click.stop="handleSlotDelete(scope.row,scope.index)">删除
        </el-button>
      </template>
      <template slot-scope="{row}"
                slot="version">
        <el-tag>v{{ row.version }}</el-tag>
      </template>
    </avue-crud>
    <el-dialog title="流程配置"
               append-to-body
               destroy-on-close
               :visible.sync="flowBox"
               :close-on-press-escape="false"
               :fullscreen="true"
               :before-close="handleNutflowClose"
               class="wf-dialog-c"
               cusom-clatss="wf-dialog">
      <wf-bm-modeler ref="wf-bm-view"
                     :xml="xml"
                     :users="users"
                     :groups="groups"
                     :categorys="categorys"
                     :exps="exps"
                     :is-view="false"
                     :bmAuth="bmAuth"
                     @save="handleSubmitModel" />
    </el-dialog>
    <dialog-reset title="流程部署"
                  :visible.sync="deployBox"
                  :slotShow='true'
                  height="auto"
                  class="lcbf"
                  width="20%">
      <avue-form ref="form"
                 :option="optionDeploy"
                 v-model="form">
      </avue-form>
      <span slot="dialog_footer"
            class="dialog-footer">
        <el-button @click="deployBox = false">取 消</el-button>
        <el-button type="primary"
                   @click="handleSubmit"
                   :loading="deployLoading">提 交</el-button>
      </span>
    </dialog-reset>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  modelList,
  removeModel,
  deployModel,
  submitModel,
  detail,
} from '@/api/flow/flow'
import { flowCategory } from '@/util/flow'
// import { getAllUserList } from '@/api/system/user'
import { getRoleTree } from '@/api/system/role'
import { getToken } from '@/util/auth'
import { removePercent } from '@/util/util'
export default {
  data() {
    return {
      bmAuth: getToken(),
      form: {},
      optionDeploy: {
        // menuBtn: false,
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            label: '流程类型',
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=flow',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            // dataType: "number",
            slot: true,
            prop: 'categoryValue',
            search: true,
            span: 24,
            rules: [
              {
                required: true,
                message: '请选择流程类型',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '流程模式',
            prop: 'flowMode',
            type: 'radio',
            dicData: [
              {
                label: '通用流程',
                value: 1,
              },
              {
                label: '定制流程',
                value: 2,
              },
            ],
            value: 1,
            span: 24,
            rules: [
              {
                required: true,
                message: '请选择流程模式',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '所属租户',
            prop: 'tenantId',
            type: 'tree',
            multiple: true,
            dicUrl: '/api/blade-system/tenant/select',
            props: {
              label: 'tenantName',
              value: 'tenantId',
            },
            display: false,
            span: 24,
            rules: [
              {
                required: true,
                message: '请选择所属租户',
                trigger: 'blur',
              },
            ],
          },
        ],
      },
      selectionId: '',
      selectionList: [],
      query: {},
      loading: true,
      deployLoading: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      deployBox: false,
      flowBox: false,
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        selection: true,
        editBtn: false,
        addBtn: false,
        viewBtn: false,
        delBtn: false,
        dialogWidth: 900,
        menuWidth: 200,
        dialogClickModal: false,
        size: 'mini',
        searchSize: 'mini',
        column: [
          {
            label: '模型主键',
            prop: 'id',
          },
          {
            label: '模型标识',
            prop: 'modelKey',
            search: true,
            overHidden: true,
          },
          {
            label: '模型名称',
            prop: 'name',
            search: true,
            overHidden: true,
          },
          {
            label: '流程版本',
            prop: 'version',
            slot: true,
            overHidden: true,
          },
          {
            label: '创建时间',
            prop: 'created',
            overHidden: true,
          },
          {
            label: '更新时间',
            prop: 'lastUpdated',
            overHidden: true,
          },
        ],
      },
      data: [],

      // 新版本
      xml: '',
      users: [],
      groups: [],
      categorys: [], // 流程类别
      exps: [],
      flowInfo: {},

      pageFlow: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
    }
  },
  watch: {
    'form.flowMode'() {
      this.$refs.form.option.column.filter((item) => {
        if (item.prop === 'tenantId') {
          item.display = this.form.flowMode === 2
        }
      })
    },
  },
  computed: {
    ...mapGetters(['permission', 'userInfo']),
    ids() {
      let ids = []
      this.selectionList.forEach((ele) => {
        ids.push(ele.id)
      })
      return ids.join(',')
    },
  },
  mounted() {
    this.getFlowData()
  },
  methods: {
    /**
     * 获取角色用户数据
     */
    getFlowData() {
      getRoleTree().then((res) => {
        let roles = res.data.data || []
        this.groups = roles
      })
      // getAllUserList({}).then((res) => {
      //   const data = res.data.data
      //   this.users = data.map(item=>{
      //     return {
      //       userId: item.account,
      //       realName: item.realName,
      //       roleName: item.roleName,
      //       deptName: item.deptName,
      //       nickName: item.realName
      //     }
      //   })
      //   console.log(this.users);
      // })
    },

    handleSubmitModel(data) {
      const elementRegistry =
        this.$refs['wf-bm-view'].modeler.get('elementRegistry')
      const processList = elementRegistry.filter(
        (item) => item.type === 'bpmn:Process'
      )
      console.log(processList[0])
      const { businessObject } = processList[0]
      const { id, name, documentation } = businessObject
      const description =
        documentation && documentation.length > 0 ? documentation[0].text : null
      const params = {
        ...this.flowInfo,
        modelKey: id,
        name,
        description,
        modelEditorXml: data.xml,
        xml: data.xml,
      }
      submitModel(params).then(() => {
        this.$message.success('操作成功')
        this.handleNutflowClose()
        this.onLoad(this.page, this.query)
      })
    },

    handleNutflowClose(done, flag) {
      const initOption = {
        id: '',
      }
      if (done || flag) {
        this.$confirm('确定要关闭吗？关闭未保存的修改都会丢失。', '警告', {
          type: 'warning',
        })
          .then(() => {
            this.xml = ''
            this.$set(this, 'flowInfo', initOption)
            if (typeof done == 'function') done()
            this.flowBox = false
          })
          .catch(() => {})
      } else {
        this.xml = ''
        this.$set(this, 'flowInfo', initOption)
        this.flowBox = false
      }
    },

    // 流程部署
    handleSubmit() {
      let that = this
      this.$refs.form.validate((valid, done) => {
        if (valid) {
          this.deployLoading = true
          deployModel({
            modelId: that.selectionId,
            category: flowCategory(that.form.categoryValue),
            tenantIds: that.form.tenantId.join(','),
          }).then((res) => {
            const data = res.data
            if (data.success) {
              that.$message({
                type: 'success',
                message: data.msg,
              })
              done()
              that.$refs.form.resetForm()
              that.deployBox = false
              that.deployLoading = false
            } else {
              done()
              that.deployLoading = false
              that.$message({
                type: 'warn',
                message: data.msg,
              })
            }
          })
        }
      })
    },
    searchReset() {
      this.query = {}
      this.onLoad(this.page)
    },
    searchChange(params, done) {
      this.query = params
      this.page.currentPage = 1
      this.onLoad(this.page, params)
      done()
    },
    selectionChange(list) {
      this.selectionList = list
    },
    selectionClear() {
      this.selectionList = []
      this.$refs.crud.toggleSelection()
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据')
        return
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return removeModel(this.ids)
        })
        .then(() => {
          this.$message({
            type: 'success',
            message: '操作成功!',
          })
          this.$refs.crud.toggleSelection()
          this.onLoad(this.page)
        })
    },
    handleCreate() {
      this.flowBox = true
    },
    handleUpdate(row) {
      detail({ id: row.id }).then((res) => {
        const data = res.data.data
        const { modelEditorXml } = data
        this.flowInfo = data
        this.xml = modelEditorXml
        this.flowBox = true
      })
    },
    handleDeploy(row) {
      this.deployBox = true
      this.selectionId = row.id
    },
    handleDoDeploy() {
      this.$refs.form.submit()
    },
    handleSlotDelete(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return removeModel(row.id)
        })
        .then(() => {
          this.$message({
            type: 'success',
            message: '操作成功!',
          })
          this.$refs.crud.toggleSelection()
          this.onLoad(this.page)
        })
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize
    },
    refreshChange() {
      this.onLoad(this.page, this.query)
    },
    onLoad(page, params = {}) {
      this.loading = true
      // 去除参数%
      //params = removePercent(this.deepClone(Object.assign(params, this.query)))
      params = removePercent(params)
      modelList(
        page.currentPage,
        page.pageSize,
        Object.assign(params, this.query)
      ).then((res) => {
        const data = res.data.data
        this.page.total = data.total
        this.data = data.records
        this.loading = false
        this.selectionClear()
      })
    },
  },
}
</script>

<style lang="scss">
.wf-dialog {
  .el-dialog__body {
    padding: 5px;
  }
  .avue-dialog__footer {
    text-align: center;
  }
}
</style>
<style scoped>
.wf-dialog-c >>> .el-dialog__body {
  padding: 10px 20px;
}
.wf-dialog-c >>> .el-table .cell .el-button i {
  width: initial;
}
.wf-dialog-c >>> .el-table__cell .el-button {
  padding: 7px 9px;
}
</style>
